import { useToast } from "@hooks";
import { confirm } from "@utils";
import { FC, useRef } from "react";
import { useTranslation } from "react-i18next";
import { ModalProps } from "../Modal/index";
import Table, { TableProps } from "../Table/Table";
import { TableModal } from "./partials/TableModal";

type Props = TableProps | ModalProps;

export const TableWithActions: FC<Props | any> = (props) => {
  const {
    size = props.size || "small",
    data,
    error,
    title,
    headers,
    onAdd,
    onDelete,
    onUpdate,
    loading,
    modalLoader,
    initialForm,
    children,
    schema,
    form,
    rowActions,
    defaultGroups,
    disablePagination,
    onRowEdit,
    disableRowFilter,
    disableFilter,
  } = props;

  const { t } = useTranslation();
  const tableModal = useRef<any>();
  const toast = useToast();

  const onRowDelete = async (id: number | string, index: number) => {
    const confirmValue = await confirm(t("attention"), t("delete_message"));
    if (!confirmValue) return;

    try {
      await onDelete(id, index);
      toast.success(t("delete_success_message"));
    } catch (error) {
      toast.error(t("error_occurred"));
    }
  };

  return (
    <>
      {form && (
        <TableModal
          initial={initialForm}
          schema={schema}
          form={form}
          ref={tableModal}
          onAdd={onAdd}
          onUpdate={onUpdate}
          loading={modalLoader}
        />
      )}
      <Table
        size={size}
        data={data || []}
        loading={loading}
        error={error}
        title={t(title)}
        headers={headers || []}
        checkbox={false}
        defaultRowActions
        rowActions={rowActions}
        onAdd={() => tableModal.current.handleOpen()}
        onRowDelete={onRowDelete}
        onRowEdit={
          onRowEdit
            ? onRowEdit
            : (item: any, index: number) =>
                tableModal.current.handleOpen(item, index)
        }
        pagination={false}
        defaultGroups={defaultGroups || []}
        disablePagination={disablePagination}
        disableRowFilter={disablePagination}
        disableFilter={disablePagination}
      >
        {children}
      </Table>
    </>
  );
};
